import { render } from "./ProformasSeriesView.vue?vue&type=template&id=bd7db086"
import script from "./ProformasSeriesView.vue?vue&type=script&lang=js"
export * from "./ProformasSeriesView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__